import Vue from "vue";
import Vuex from "vuex";

import auth from "./shared/state/auth";
import app_settings from "./shared/state/app_settings";
import * as helpers from "./shared/services/helpers";
import { registration, clientOffers, profile, applications } from "./client/client-states";
import {
    mobile_registration,
    mobile_clientOffers,
    mobile_profile,
    mobile_applications,
} from "./mobile/client-states";
import {
    deals,
    notifications,
    economics,
    adminOffers,
    users,
    events,
    triggers,
    adminSettings,
    templates,
    statistics,
    applications as adminApplications,
} from "./admin/admin-states";

function states() {
    if (helpers.isMobile()) {
        return { mobile_registration, mobile_clientOffers, mobile_profile, mobile_applications };
    } else {
        return { registration, clientOffers, profile, applications };
    }
}

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        app_settings,
        auth,
        ...states(),
        adminOffers,
        deals,
        notifications,
        economics,
        users,
        templates,
        events,
        triggers,
        adminSettings,
        statistics,
        adminApplications,
    },
});
